module.exports = __webpack_public_path__ + "img/21_fineStaff_lxy.3628534e.png";